import Vue from 'vue'

const setCookie = (token, value) => {
  Vue.$cookies.set(token, value)
}

const getCookie = (token) => {
  Vue.$cookies.get(token)
}

const removeCookie = (token) => {
  Vue.$cookies.remove(token)
}

const isCookie = (token) => {
  Vue.$cookies.isKey(token)
}

export { setCookie, getCookie, removeCookie, isCookie }



// WEBPACK FOOTER //
// ./src/utils/cookies.js